import React from 'react';
import Layout from '../../components/Layout';
import HomeServicesPillar from './HomeServicesPillar';
import NotFound from '../../components/NotFound/NotFound';
import { pillarCityBySlug } from '../../core/seo/pillarCities';

// Public city "Home Services" pillar hub: /home-services/:citySlug (regional-focus SEO).
async function action({ params, store }) {
  const siteTitle =
    (store.getState().siteSettings && store.getState().siteSettings.data && store.getState().siteSettings.data.siteTitle) ||
    'BestHand';

  const city = pillarCityBySlug(params.citySlug);
  if (!city) {
    return {
      title: `Page Not Found | ${siteTitle}`,
      status: 404,
      component: (<Layout><NotFound title={'Page Not Found'} /></Layout>),
    };
  }

  const place = `${city.name}, ${city.state}`;
  return {
    title: `Home Services in ${place} | ${siteTitle}`,
    // COMPLIANCE: background-check claim is intentional (founder confirms BestHand performs background checks). LEGAL_REVIEW_REQUIRED before prod.
    description: `Book trusted, background-checked local pros for home services in ${place} — handyman, cleaning, plumbing, electrical, moving and more. Upfront pricing, no lead fees, secure in-app payment.`,
    component: (<Layout><HomeServicesPillar city={city} /></Layout>),
  };
}

export default action;
